import * as React from "react";
// Styles
import styles from "./index.module.scss";

interface IProps {
	style?: object;
	children?: React.ReactNode;
}

const Enamad: React.FC<IProps> = ({ children, ...restProps }) => {
	return (
		<div className={styles["enamad"]} {...restProps}>
			<a
				target="_blank"
				rel="noopener noreferrer"
				href="https://trustseal.enamad.ir/?id=139163&Code=0gcTsbjXwPzOF6T0SwPT"
			>
				<img
					src="https://trustseal.enamad.ir/logo.aspx?id=139163&Code=0gcTsbjXwPzOF6T0SwPT"
					id="Bv6sDST4Nh9puyKQYUIN"
					alt="enamad"
				/>
			</a>
		</div>
	);
};

export default Enamad;
